<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-center text-secondary pb-2 pe-2">{{ title }}</h3>
  </div>
  <div class="modal-body">
    <ng-template [ngIf]="isTemplateRef(message)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="message"></ng-template>
    </ng-template>
    <div class="d-flex justify-content-center">
      <button type="button" (click)="close()" class="btn btn-primary w-50 self-align-center">OK</button>
    </div>
  </div>
</div>
<ng-template #text>
  <p>{{ message }}</p>
</ng-template>
